module.exports = __webpack_public_path__ + "static/img/9.078a894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changeBg/9.png
// module id = l2Ua
// module chunks = 0